 <!-- new  move -->
<template>
    <div id="invMove">
        <a-modal title="Move" :visible="visible" width="85%" @cancel="moveHandleCancel" :maskClosable=false :footer="null">
            <a-form :form="form" >
                   <!-- warehouse -->
                    <a-form-item
                         :label="$t('userlang.Warehouse')"
                         :label-col="{ span: 3 }"
                         :wrapper-col="{ span: 8 }">
                        <a-select
                                show-search
                                 optionFilterProp="label"
                                size="small"
                                :disabled="true"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                v-decorator="[
                                'warehouseCode',
                                {
                                  initialValue: warehouseCode,
                                  rules: [{
                                    required: true,
                                    message: $t('publicLang.Required')
                                  }]
                                }
                              ]">
                            <a-select-option :label="item.whsName"  :value="item.whsCode" :key="item.whsCode" v-for="item in wareHouseSelect">{{item.whsName}}</a-select-option>
                        </a-select>
                    </a-form-item>


                <!-- Reason -->
                <a-form-item :label="$t('pubGicSet.Reason')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-select allowClear show-search optionFilterProp="label" size="small"
                        :placeholder="$t('publicLang.PleaseSelect')" @change="moveReasonChange" v-decorator="[
                            'reasonCode',
                            {
                              initialValue: reasonCode,
                              rules: [{
                               required: this.reasonMandatory,
                                message:  $t('publicLang.Required')
                              }]
                            }
                          ]">
                        <a-select-option :label="item.codeDesc" v-for="item in moveReasonSelectData" :key="item.code"
                            :value="item.code">{{item.codeDesc}}</a-select-option>
                    </a-select>
                </a-form-item>


                <!-- remarks -->
                <a-form-item :label="$t('pubGicSet.Remarks')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-textarea :placeholder="$t('pubGicSet.Remarks')" :rows="3" size="small" v-model="remarksVal" />
                </a-form-item>
            </a-form>

            <a-col style="float:right;">
                <a-button  class="mg5" size="small" type="primary" style="margin-right: 8px"  @click="saveMoveHeader" v-if="headerStatus == '10' ? false : headerStatus == '90' ? false:true " >
                    {{ $t('publicLang.Save') }}</a-button>
                <a-button class="mg5" size="small" type="primary"  @click="addMoveTable"  v-if="headerStatus != '00' ? false : true"  >{{ $t('pubGicSet.Search') }}</a-button>
            </a-col>

            <a-divider style="margin: 10px 0px"  />

            <!-- header save  -->
            <a-row style="margin-bottom: 10px;" >
                <a-col style="float:left;">
                    <!-- colse -->
                    <a-button size="small" @click="moveHandleCancel">{{ $t('publicLang.Close') }}</a-button>
                    <!-- save inv moveDetail  -->
                    <a-button  class="mg5" size="small" type="primary" @click="saveMoveDetails"   v-if="headerStatus != '00' ? false : true"   :disabled="this.tableData.length > 0 ? this.isShowUpdateMoveDetailBTN : true"  >{{ $t('publicLang.Save') }}</a-button>

                    <!-- cancel  -->
                    <a-popconfirm :title="$t('publicLang.Arecancel')" @confirm="moveCancel" :okText="$t('publicLang.Yes')"
                                  :cancelText="$t('publicLang.No')">
                        <a-button class="mg5" size="small" type="primary"    v-if="headerStatus != '00' ? false : true" >{{ $t('publicLang.Cancel') }}</a-button>
                    </a-popconfirm>

                    <!-- confirm  -->
                    <a-popconfirm :title="$t('publicLang.Areconfirm')" @confirm="confirmMove" :okText="$t('publicLang.Yes')"
                                  :cancelText="$t('publicLang.No')">
                        <a-button class="mg5" size="small" type="primary" :style= "tableData.size > 0 ? '':'margin-left: 5px;'"    v-if="headerStatus != '00' ? false : true"   :disabled="this.tableData.length > 0 ? false : true" >{{ $t('publicLang.Confirm') }}</a-button>
                    </a-popconfirm>

                    <!--添加库位输入框,如果有值则代替下方列表To Location的值 Liyy 2023-3-30-->
                    <b style="margin-left: 5px;">{{$t('pubGicSet.Location')}}:</b>
                    <a-auto-complete style="width: 200px;border: 0px solid;" @search="handleSearch" :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="topLocation" >
                        <template slot="dataSource">
                            <a-select-option v-for="item in completeData" :key="item.locationCode"  :value="item.locationCode">{{item.locationName}}</a-select-option>
                        </template>
                    </a-auto-complete>
                </a-col>
            </a-row>


            <vxe-table


                        border
                        resizable
                        stripe
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                     
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        align="center"
                        :data.sync="tableData"
                        class="mytable-style "
                        max-height="350"
                        ref="refMoveDetailTab"
                        size="mini"
             >

    <!-- border resizable size="mini" :data="tableData"
                 keep-source
                 :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                 ref="refMoveDetailTab" -->
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column field="sku" :title="$t('pubGicSet.SKU')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="palletId" :title="$t('batchReceive.PalletID')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="cartonId" :title="$t('batchReceive.CartonID')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="logicWhs" :title="$t('pubGicSet.LogicalWH')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="avBaseQty" :title="$t('pubGicSet.AvailableQty')"
                    show-header-overflow="ellipsis" show-overflow="ellipsis"
                  ></vxe-table-column>
                <vxe-table-column field="fromLocation" :title="$t('pubGicSet.FromLocation')"
                    show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="moveQty" :title="$t('pubGicSet.MoveQty')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-input-number :placeholder="$t('publicLang.PleaseEnter')" :min="1" v-model="row.moveQty"
                            size="small" style="width: 100%;" @change="handleChange"  />
                    </template>
                </vxe-table-column>
                <vxe-table-column field="toLocation" :title="$t('pubGicSet.ToLocation')" show-header-overflow="ellipsis"
                    show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-auto-complete style="width: 100%;" @search="handleSearch" @change="handleChange"
                            :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="row.toLocation">
                            <template slot="dataSource">
                                <a-select-option v-for="item in completeData" :key="item.locationCode"  :value="item.locationCode">{{item.locationName}}</a-select-option>
                            </template>
                        </a-auto-complete>
                    </template>
                </vxe-table-column>
                <vxe-table-column :title="$t('generic.operate')" width="150" show-header-overflow="ellipsis"
                    show-overflow="ellipsis"  v-if="headerStatus != '00' ? false : true" >
                    <template v-slot="{ row }">
                        <img @click="deleteRows(row)" style="margin-left: 4px" class="sbxs"
                            src="../../../assets/img/ss-delete.png" width="22" height="22" >
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-modal>
        <move-search ref="MoveAdvan" :searTableUid="moveSearTableUid" :adjustParHeaderId="moveHeaderUid"
            :waseCode="moveWarehouse" v-on:getAdjustData="getAdjustData" :ajtype="adjust"></move-search>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import cookie from '../../../api/cookie'
    import api from '../../../api/url'
    import moveSearch from './adjustAdvanSearch/moveSearch.vue'

    export default {
        components: {
            moveSearch
        },
        data() {
            return {
                ifCancel: true,
                ifSearch: true,
                visible: false,
                form: this.$form.createForm(this),
                tableData: [],
                movelogicSelectData: [],
                moveReasonSelectData: [],
                wareHouseSelect: [],
                moveHeaderUid: "",
                moveSearTableUid: "",
                adjust: 'invMoveDetail',
                completeData: [],
                moveWarehouse: '', // ware code select
                isCancelMoveEvent: true,
                wareHourseDis: false,
                isSaveClick: true,
                //                chang 事件
                remarksVal: '',
                moveLogicVal: '',
                reasonCode: '',
                movePatwaytype: '',
                editInvMoveHeader: {},
                type: '',
                editType: '',
                dataType: "",

                pageSizeOptions: ['10', '20', '30', '40', '100', '200', '500', '1000'],
                pagingTotal: 0, // 总数
                pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
                currentVal: 1, // 页数
                headerStatus:'',
                warehouseCode: '',
                reasonMandatory: false,
                topLocation:"",
                isShowUpdateMoveDetailBTN: true
            }
        },
        methods: {
              handleChange(){
                 let records = this.$refs.refMoveDetailTab.getRecordset();
                 console.info(records)
                 let updateRecords = records.updateRecords
                 if(updateRecords != null && updateRecords.length > 0){
                    this.isShowUpdateMoveDetailBTN = false
                 }else{
                    this.isShowUpdateMoveDetailBTN = true
                 }
            },
        checkData(array,isIgnoreTopToLocation){ //isIgnoreTopToLocation 是否忽略TopToLocation
            
            if(array != null && array.length > 0){
                let errorMsg = '';
                let toLocationEmpty = '';
                let notEnoughInventory = '';
                for(let i in array){
                     let row = array[i];
                     let sku  = row.sku;
                     let  fromLocation = row.fromLocation
                     let msg = "SKU#"+sku+" "+fromLocation
                     
                     let topLocationIsNull = (this.topLocation == null || this.topLocation == '') ;

                    if(isIgnoreTopToLocation){
                        topLocationIsNull = true;
                    }

                     if ( topLocationIsNull  && (row.toLocation == null || row.toLocation == '')) {
                            if(toLocationEmpty.indexOf(msg) > -1){
                              continue;
                             } 
                             if(toLocationEmpty.length > 0){
                                 toLocationEmpty += ','
                             }
                             toLocationEmpty += msg
                     }
                     

                     if(parseInt(row.moveQty) > row.avBaseQty ){
                       

                         if(notEnoughInventory.indexOf(msg) > -1){
                            continue;
                        } 

                        if(notEnoughInventory.length > 0){
                            notEnoughInventory += ','
                        }
                        notEnoughInventory += msg
                     }
                }     
                
                if(toLocationEmpty.length > 0){
                    if(errorMsg.length > 0){
                        errorMsg += '\n';
                    }
                    errorMsg += toLocationEmpty+" "+this.$t("pubGicSet.ToLocationCannotBeEmpty");
                } 
                   
                if(notEnoughInventory.length > 0){
                    if(errorMsg.length > 0){
                        errorMsg += '\n';
                    }
                    errorMsg += notEnoughInventory +" "+this.$t("pubGicSet.NotEnoughInventoryToMove");
                 } 
                
                if(errorMsg.length > 0){
                       throw new Error(errorMsg);
                }    
            }
        },



            saveMoveDetails(){
        
             let records = this.$refs.refMoveDetailTab.getRecordset();
             let updateRecords = records.updateRecords
             if( (this.topLocation == null  || this.topLocation == '' || this.topLocation == undefined ) && (updateRecords == null || updateRecords.length == 0)){
                this.$customMessage.error(this.$t("pubGicSet.DataNotChange"));
                return;
             }

              try{
                  this.checkData(updateRecords,true);  
              } catch (error){
                 this.$customMessage.error(error.message);
                 return;
              }
           

               ajax.post(api.UPDATEINVMOVEDETAIL,updateRecords).then(res=>{
                   if(res.code == 200){
                       this.form.resetFields();
                       this.show2(this.moveHeaderUid,false)
                       this.$message.success(res.msg);
                   }else{
                       this.$customMessage.warning(res.msg);
                   }
               })
                
            },
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                  this.changePage();
            },
            //      表格分页
            tableChangePage(current) {
                this.currentVal = current;
              this.changePage();
            },

            moveWarehouseChange(val) {
                this.moveWarehouse = val
            },
            moveLogicChange(val) {
                this.moveLogicVal = val
            },
            moveReasonChange(val) {
                this.reasonCode = val
            },
            moveHandleCancel() {
                this.visible = false
                this.wareHourseDis = false
                this.tableData = []
                this.isCancelMoveEvent = true
                this.remarksVal = ''
                this.ifCancel = true
                this.ifSearch = true
                this.isSaveClick = true
                this.moveHeaderUid = ''
                this.form.resetFields();
                this.editInvMoveHeader = {}
                this.topLocation = ""
            },
            show2(uid,init){
                    if(init){ this.init(); }
                    ajax.get(api.INVENTORYINVMOVEINFO, {uid: uid}).then(res => {
                        if(res.code == 200){
                             this.headerStatus = res.data.status
                            this.tableData = res.data.invMoveDetailDtos
                            this.moveHeaderUid  = res.data.uid
                            this.remarksVal = res.data.remarks
                            this.moveSearTableUid = res.data.gmcUid
                            this.reasonCode = res.data.reasonCode
                            this.warehouseCode = res.data.whsCode
                            this.visible = true;
                            this.isShowUpdateMoveDetailBTN = true

                            let locationCodes = '';
                             for(let i in this.tableData){
                                let locationCode = this.tableData[i].toLocation
                                if(locationCode != null && locationCode != ''){
                                       if(locationCodes.length > 0){
                                            locationCodes = locationCodes +','+locationCode
                                       }else{
                                            locationCodes =  locationCode
                                       }
                                }
                            }
                            // this.handleSearch(locationCodes)
                        }else{
                             this.$customMessage.error(res.msg);
                        }
                    })
                    
            } ,
            show(params) {    
                if(params != null){
                    ajax.post(api.EDITINVRNTORYINVSAVE, params).then(res => {   // 保存 生成数据
                        if (res.code == 501) {
                            this.visible = false
                            this.$customMessage.error(res.msg);
                            return
                        }else if(res.code == 200){              // 生成move  数据成功
                           this.moveHeaderUid = res.data.uid;   
                           this.show2(this.moveHeaderUid,true)
                        }
                    })
                }else{
                    this.init();
                    this.visible = true
                }
            },

            changePage() { // 切换页码
                let params = {};
                params.uid = this.moveHeaderUid;
                if (this.dataType == 'PUTAWAY') {
                    params.pageNum = this.currentVal
                    params.pageSize = this.pagingSize
                }

                ajax.get(api.INVENTORYINVMOVE, params).then(res => {
                    if (this.dataType == 'PUTAWAY') {
                        this.tableData = res.data.data
                        this.pagingTotal = res.data.pagingTotal;
                    } else {
                        this.tableData = res.data
                    }
                })
            },

            //            初始化获取 个个下拉data
            init() {
                this.headerStatus = ''
                this.moveHeaderUid = ''
                this.reasonCode=''
                this.remarksVal = ''
                this.warehouseCode = ''
                this.tableData = []
                this.form.resetFields();
                  ajax.get(api.USERDROPDOWNWHS).then(res=>{
                    if(res.code == 200){
                        this.wareHouseSelect = res.data.warehouseList
                        this.warehouseCode = res.data.warehouseCode
                        // 设置初始值，否则可能会存在moveSearch wareCode为Null
                        this.moveWarehouse = this.warehouseCode
                    }
                })

                ajax.get(api.MOVEREASONSELECT).then(res => {
                    // this.moveReasonSelectData = res.data
                   this.moveReasonSelectData = res.data.reasons
                    this.reasonMandatory = res.data.reasonMandatory
                })
            },
            //            header save
            saveMoveHeader() {
                this.form.validateFields((err, val) => {
                    if (!err) {
                        let params = {
                            uid : this.moveHeaderUid,
                            remarks: this.remarksVal,
                            reasonCode: val.reasonCode
                        }
                        ajax.post(api.INVMOVEHEADER, params).then(res => {
                            if (res.code == 200) {
                                this.moveHeaderUid = res.data.headerUid
                                this.moveSearTableUid = res.data.gmcUid
                                this.headerStatus = res.data.status
                                 this.$message.success(res.msg);
                            } else {
                                this.$customMessage.error(res.msg)
                            }

                        })
                    }
                })
            },
            //            move cancel
            moveCancel() {
                ajax.post(api.INVENTORYMOVECANCEL, {
                    uid: this.moveHeaderUid
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                         this.headerStatus ='10'
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            },
            addMoveTable() {
                this.$refs.MoveAdvan.show()
            },
            getAdjustData(val) {
                this.tableData = val
                this.isShowUpdateMoveDetailBTN = true
            },
            deleteRows(row) {
                ajax.post(api.DELINVMOVEDETAIL, {
                    uid: row.uid,
                    headerUid: this.moveHeaderUid,
                }).then(res => {
                    if (res.code == 200) {
                         this.$refs.refMoveDetailTab.remove(row)
                        this.$message.success(res.msg)
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            },
            handleSearch(value) {
                if (value == '' || value.length < 4) {
                    return
                }
                ajax.post(api.INVENTORYLOCATION, { keyword: value}).then(res => {
                    this.completeData = res.data
                })
            },
            confirmMove() {
                 this.form.validateFields((err, val) => {
                    if (!err) {
                              if(!(this.isShowUpdateMoveDetailBTN)){
                                   this.$customMessage.error(this.$t("pubGicSet.DataModifyNotSave"));
                                   return;
                              }

                             try{
                                  this.checkData(this.tableData,false);  
                              } catch (error){
                                 this.$customMessage.error(error.message);
                                 return;
                              }


                             let params = {
                                 logic: this.moveLogicVal,
                                 remarks: this.remarksVal,
                                 uid: this.moveHeaderUid,
                                 updateInvDetailVos: [],
                                 whsCode: this.moveWarehouse,
                                 reasonCode: this.reasonCode,
                                 topLocation: this.topLocation,
                                 dataType: 'Move'
                             }

                             ajax.post(api.MOVECONFIRMINVENTORY, params).then(res => {
                                 if (res.code == 200) {
                                     this.headerStatus = '10'
                                     this.show2(this.moveHeaderUid,false)
                                     this.$message.success(res.msg)
                                     this.topLocation = ""
                                 } else {
                                     this.$customMessage.error(res.msg)
                                 }
                             })
                    }
                })
            }
        }
    }
</script>